import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Spinner = (props) => {
  if (MOBILE_WALLET) {
    const spinnerClasses = cx({
      spinner: true,
      'spinner--size-tiny': props.size === 'tiny',
    });

    return (
      <div className={spinnerClasses} />
    );
  }

  const spinnerClasses = cx({
    spinner__item: true,
    'spinner__item--size-tiny': props.size === 'tiny',
  });

  return (
    <div className="spinner">
      <span className={spinnerClasses} />
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.string,
};

export default Spinner;
